import { jsxs as g, jsx as e } from "react/jsx-runtime";
import n from "./index.es5872.js";
import { useDatePicker as h } from "./index.es851.js";
import { Dropdown as r } from "./index.es72.js";
import { BasicDropdownMenu as o } from "./index.es73.js";
import { DatePickerHeaderSelector as i } from "./index.es5869.js";
const x = ({
  monthLabel: a,
  monthDropdownTestId: s,
  monthsItems: c,
  yearsDropdownTestId: d,
  yearsItems: m,
  yearsLabel: l,
  onMonthChange: p,
  onYearsChange: u
}) => {
  const { setRangeDropdownOpen: t } = h();
  return /* @__PURE__ */ g("div", { className: n.rangeSelectContainer, children: [
    /* @__PURE__ */ e("div", { className: n.monthMenu, children: /* @__PURE__ */ e(
      r,
      {
        closeOnSelection: !0,
        appendToParent: !0,
        testId: s,
        trigger: /* @__PURE__ */ e(i, { value: a }),
        align: "center",
        side: "bottom",
        menuWidth: 151,
        onOpenChange: t,
        children: /* @__PURE__ */ e(o, { items: c, onSelection: p })
      }
    ) }),
    /* @__PURE__ */ e("div", { className: n.yearMenu, tabIndex: -1, children: /* @__PURE__ */ e(
      r,
      {
        closeOnSelection: !0,
        appendToParent: !0,
        testId: d,
        trigger: /* @__PURE__ */ e(i, { value: l }),
        align: "center",
        side: "bottom",
        menuWidth: 92,
        onOpenChange: t,
        children: /* @__PURE__ */ e(o, { items: m, onSelection: u })
      }
    ) })
  ] });
};
export {
  x as RangeDropdowns
};
//# sourceMappingURL=index.es5865.js.map
